'use client'

import { Typography } from 'src/components/design-system'

export default function FilterCheckboxOption({
  checked,
  disabled = false,
  onChange,
  children,
  label,
  labelVariant = 'body3-normal',
  className = 'cursor-pointer flex items-center gap-8',
  checkboxClassName = 'h-16 min-w-16 cursor-pointer appearance-none rounded-1 border border-basic-black bg-basic-white checked:shadow-[inset_0_0_0_2px_rgb(255,255,255)] checked:bg-basic-black',
}) {
  return (
    <label className={`${className} ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}>
      <input
        type="checkbox"
        checked={Boolean(checked)}
        disabled={disabled}
        onChange={onChange}
        className={checkboxClassName}
      />
      {children ?? <Typography variant={labelVariant}>{label}</Typography>}
    </label>
  )
}
